import { create } from "zustand";

export interface MorphRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

interface SheetMorphState {
  /** A pending morph request, or null. `token` makes each request distinct. */
  pending: { token: number; taskId: string; source: MorphRect } | null;
  /** Fire a popup→element morph: animate a clone from `source` to the new
   *  block's slot (resolved by `taskId`). No-op visuals if the slot isn't on
   *  screen — the sheet has already closed. */
  fire: (taskId: string, source: MorphRect) => void;
  clear: () => void;
}

let seq = 0;

/** Drives the "drop into place" animation: after a save on a calendar route the
 *  sheet hands its rect + the saved task id here, and SheetMorph (mounted in
 *  Shell) flies a styled clone into the calendar block. */
export const useSheetMorphStore = create<SheetMorphState>((set) => ({
  pending: null,
  fire: (taskId, source) => set({ pending: { token: ++seq, taskId, source } }),
  clear: () => set({ pending: null }),
}));
